module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/check-white-green-ef3c4d92.svg";